import { ChevronLeft, ChevronRight } from '@app/components/various/Icons';
import { cn } from '@app/utils/cn';
import { useTranslation } from 'react-i18next';

import { Button } from '../Button';

interface Props {
  onChange: (index: number) => void;
  currentIndex: number;
  lastIndex: number;
}

export const LightboxPagination = ({ onChange, currentIndex, lastIndex }: Props) => {
  const { t } = useTranslation(['common']);

  const isPrevEnabled = currentIndex > 0;
  const isNextEnabled = currentIndex < lastIndex;

  return (
    <div className="absolute bottom-5 z-pagination mt-auto flex items-center rounded-regular bg-white">
      <ul className={cn('flex flex-1 list-none items-center gap-2 px-3 py-2 sm:justify-center')}>
        <Button
          variant="ghost"
          color="secondary"
          ariaLabel={t('common:previous_media')}
          onClick={isPrevEnabled ? () => onChange(currentIndex - 1) : undefined}
          disabled={!isPrevEnabled}
          icon={ChevronLeft}
        />

        <li className="lg:hidden">
          <span className="px-2 body-1">
            {currentIndex + 1}/{lastIndex + 1}
          </span>
        </li>

        <Button
          variant="ghost"
          color="secondary"
          ariaLabel={t('common:next_media')}
          disabled={!isNextEnabled}
          onClick={isNextEnabled ? () => onChange(currentIndex + 1) : undefined}
          className="w-10"
          icon={ChevronRight}
        />
      </ul>
    </div>
  );
};
